import React, { Component } from 'react';
import styled from 'styled-components';
import { PopulationDataType, SupportCategoryType } from '../../types';

type Props = {
  year?: number;
  dataType?: PopulationDataType; //total population
  targetAreaName: string;
  targetAreaValue?: number;
  ranking?: Ranking;
  isProportionValue: boolean;
  isKu: boolean;
  isTotalDataType: boolean;
  isSimilarity: boolean;
  supportType: SupportCategoryType;
};

export type Ranking = {
  rankingInKu: number;
  rankingInCity: number | undefined;
  rankingInKuPerPopulation: number | undefined;
  rankingInCityPerPopulation: number | undefined;
  kuCount: number;
  cityCount: number;
  selectedCityName: string | undefined;
};

class RankingLegendComponent extends Component<Props> {
  render() {
    const {
      year,
      dataType,
      targetAreaName,
      targetAreaValue,
      ranking,
      isProportionValue,
      isKu,
      isTotalDataType,
      isSimilarity,
      supportType
    } = this.props;

    return (
      <RankingLegend>
        {/* マップのタイトルを表示 */}
        <MapTitle>
          {year}年の
          {isSimilarity
            ? ''
            : dataType === PopulationDataType.Support
            ? supportType
            : dataType}
          {isSimilarity
            ? '類似地域（' + targetAreaName + ')'
            : isProportionValue
            ? 'の割合（1999年比）'
            : ''}
        </MapTitle>
        {/* Mapのデータを表示 */}
        <Data isVisible={!isSimilarity}>
          <p>
            {targetAreaName}：{targetAreaValue}
            {typeof targetAreaValue === 'number'
              ? isProportionValue
                ? '%'
                : dataType === PopulationDataType.Household
                ? '世帯'
                : '人'
              : 'データがありません'}
          </p>
          <RankingBox isVisible={!isProportionValue}>
            {typeof targetAreaValue === 'number' && ranking ? (
              <table>
                <tbody>
                  <tr>
                    <StyledTd></StyledTd>
                    <StyledTd>
                      {isKu
                        ? `川崎市${ranking.kuCount}区`
                        : `${ranking.selectedCityName ?? ''}${
                            ranking.kuCount
                          }エリア`}
                      中
                    </StyledTd>
                    {!isKu ? (
                      <StyledTd>川崎市{ranking.cityCount}エリア中</StyledTd>
                    ) : null}
                  </tr>
                  <tr>
                    <StyledTd>総計</StyledTd>
                    <StyledTd>{ranking.rankingInKu || '-'}位</StyledTd>
                    {!isKu ? (
                      <StyledTd>{ranking.rankingInCity || '-'}位</StyledTd>
                    ) : null}
                  </tr>
                  {!isTotalDataType ? (
                    <tr>
                      <StyledTd>人口あたり割合</StyledTd>
                      <StyledTd>
                        {ranking.rankingInKuPerPopulation || '-'}位
                      </StyledTd>
                      {!isKu ? (
                        <StyledTd>
                          {ranking.rankingInCityPerPopulation || '-'}位
                        </StyledTd>
                      ) : null}
                    </tr>
                  ) : null}
                </tbody>
              </table>
            ) : null}
            {/* 総人口データ以外の場合、以下で人口あたりの比率ランキングを表示 */}
          </RankingBox>
        </Data>
      </RankingLegend>
    );
  }
}

const RankingLegend = styled.div`
  display: inline-block;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  position: absolute;
  background-color: rgba(255, 255, 255, 0.9);
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.3);
  border-radius: 2px;
  padding: 6px 12px;
  border-radius: 2px;
  background: #fff;
  line-height: 1.8em;
  color: #333;
  z-index: 800;
`;

const MapTitle = styled.div`
  font-size: 14px;
  font-weight: bold;
`;

const Data = styled.div<{ isVisible: boolean }>`
  font-size: 12px;
  display: ${props => (props.isVisible ? 'block' : 'none')};
`;

const RankingBox = styled.div<{ isVisible: boolean }>`
  display: ${props => (props.isVisible ? 'inline-block' : 'none')};
`;

const StyledTd = styled.td`
  border: solid 1px #555;
`;
export default RankingLegendComponent;
